import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const StatusDashboardIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.35707 12.0001V16.8572H5.9285V12.0001H8.35707ZM11.9999 7.14293V16.8572H9.57136V7.14293H11.9999ZM21.7142 18.0715V19.2858H2.28564V4.71436H3.49993V18.0715H21.7142ZM15.6428 9.5715V16.8572H13.2142V9.5715H15.6428ZM19.2856 5.92864V16.8572H16.8571V5.92864H19.2856Z'
                fill='currentColor'
            />
        </>
    ),
})

StatusDashboardIcon.displayName = 'StatusDashboardIcon'
